export type VendorUiCapability =
  | 'currencySelector'
  | 'multiCurrencyEnableCta'
  | 'multiCurrencyBanner'
  | 'bankDetailsDialog'
  | 'addCurrencyCta'
  | 'autoWithdrawalSettings';

export enum VendorBankingUiMode {
  LegacyPending = 'LEGACY_PENDING',
  LegacyWithVendorVban = 'LEGACY_WITH_VENDOR_VBAN',
  UsdVbanActive = 'USD_VBAN_ACTIVE',
  MultiCurrency = 'MULTI_CURRENCY',
}
